import { useMemo } from "react";
import { ImageIcon, OfficeIcon, PDFIcon, VideoIcon, WeblinkIcon } from "Assets";
import { BlobTypes } from "modules/generic.types";

interface FileTypeIconProps {
  type?: BlobTypes;
  className?: string;
}

export const FileTypeIcon = ({ type, className }: FileTypeIconProps) => {
  const Icon = useMemo(() => {
    const lowercaseType = type?.toLocaleLowerCase();
    switch (lowercaseType) {
      case "mp4":
      case "mov":
        return VideoIcon;
      case "pdf":
        return PDFIcon;
      case "jpeg":
      case "jpg":
      case "png":
        return ImageIcon;
      case "ppt":
      case "pptx":
      case "doc":
      case "docx":
      case "xls":
      case "xlsx":
        return OfficeIcon;
      default:
        return WeblinkIcon;
    }
  }, [type]);

  return <Icon className={className} />;
};
